import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickDelete } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient, queryClient } from "../../clients";

import type { IMemberWorkingExperience } from "./routeType";
import { useGetAllMemberWorkingExperiences } from "./getAll";
import { useGetMemberWorkingExperience } from "./get";

const { getPath } = getApi("members.workingExperience.delete");

type IExtractedRouteType =
  IMemberWorkingExperience["workingExperienceSingleDelete"];

export type IDeleteMemberWorkingExperience = IPickDelete<IExtractedRouteType>;

const deleteMemberWorkingExperience: MutationFunction<
  IDeleteMemberWorkingExperience["response"],
  IDeleteMemberWorkingExperience["variables"]
> = ({ experienceId }) => {
  return axiosClient.delete(getPath({ experienceId }));
};

export const useDeleteMemberWorkingExperience = createMutation({
  mutationFn: deleteMemberWorkingExperience,
  onSuccess: (_, { experienceId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberWorkingExperiences.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberWorkingExperience.getKey({ experienceId }),
    });
  },
});
